import { createContext } from 'react';
import type { IdentityUser } from '../../features/user/types/user';

export interface AuthContextType {
  user: IdentityUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  signIn: (user: IdentityUser) => Promise<void>;
  logout: () => Promise<void>;
  setUser: (user: IdentityUser) => void;
  setAuthPhoneNumber: (phoneNumber: string) => void;
  authPhoneNumber: string | null;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
